export const doublebyteChecker = input => {
  const kanjiRegex = /[\u4E00-\u9fbf]/;
  return kanjiRegex.test(input);
};
